/**
 * Monto → USDT para ELEGIR el tramo (23/10/2026, tramos por distancia).
 *
 * El GET de tramos (`rates/tramos-usdt/*` y `rates-public/tramos-*`) puede
 * traer `precioCorte`: el precio del USDT con que el servidor convierte el
 * monto a USDT para elegir el tramo. Con `TRAMOS_CONVERSION_MONTO =
 * REFERENCIA` es el PROM P2P (rutas VES) o el spot (rutas CLP): `USDT = VES ÷
 * precioCorte` o `CLP ÷ precioCorte`.
 *
 * Solo cambia QUÉ tramo se elige. Las tasas que se muestran y se cobran siguen
 * siendo las que publica el API: acá nunca se calcula una tasa.
 *
 * «No romper»: sin `precioCorte` válido (backend viejo, null, 0, NaN) se usa el
 * divisor de hoy de cada pantalla, tal cual, sin redondeos ni guardas nuevas.
 */

/** `precioCorte` usable: número finito y mayor que 0. Si no, null. */
export function precioCorteValido(precioCorte: unknown): number | null {
  if (precioCorte == null || precioCorte === '') return null;
  const n = Number(precioCorte);
  return Number.isFinite(n) && n > 0 ? n : null;
}

/**
 * Con qué se divide el monto para pasarlo a USDT: `precioCorte` si es válido;
 * si no, `fallbackDivisor` TAL CUAL llega (puede ser null: la pantalla decide
 * qué hacer sin divisor, como hoy).
 */
export function divisorParaTramo<T>(precioCorte: unknown, fallbackDivisor: T): number | T {
  const p = precioCorteValido(precioCorte);
  return p !== null ? p : fallbackDivisor;
}

/**
 * Los USDT con que se elige el tramo para `monto` (en VES o CLP):
 * `monto ÷ precioCorte` si es válido; si no, `monto ÷ fallbackDivisor`, la
 * misma división de hoy (la base de la pantalla).
 */
export function montoEnUsdtParaTramo(
  monto: number,
  precioCorte: number | null | undefined,
  fallbackDivisor: number,
): number {
  return monto / divisorParaTramo(precioCorte, fallbackDivisor);
}
